export function Log(...args) {
	if (process.env.REACT_APP_ENVIRONMENT.toLowerCase() === "development") {
		console.log(...args);
	}
}